import React from 'react';
import { useApp } from '../context/AppContext';

// A thin bar across the top when the server is serving a newer build than this
// tab is running.
//
// Deploys land several times a day, and a page left open — a laptop tab from
// yesterday, a phone in a pocket — keeps running the code it loaded. The
// buttons a deploy added are not on that screen at all, so tapping where they
// should be does nothing, which reads as the app being broken rather than old.
//
// It never reloads on its own. Somebody halfway through writing an estimate
// must not have the page pulled out from under them; the offer sits there
// until they take it.
//
// The styling is in index.css under `.topbar`, not here. It used to be inline
// with `top: 0` and no safe-area padding, which on an iPhone put the Reload
// button underneath the status bar — an offer to update the app that could
// not be tapped, on the one screen that exists to be tapped.
export default function UpdateBar() {
  const { newBuild } = useApp();
  if (!newBuild) return null;

  return (
    <div className="topbar topbar-update" role="status">
      <span>A newer version of the app is available.</span>
      <button type="button" onClick={() => window.location.reload()}>Reload</button>
    </div>
  );
}
